import { render, staticRenderFns } from "./disclaimers.vue?vue&type=template&id=a6d8bf66&scoped=true&"
import script from "./disclaimers.vue?vue&type=script&lang=js&"
export * from "./disclaimers.vue?vue&type=script&lang=js&"
import style0 from "./disclaimers.vue?vue&type=style&index=0&id=a6d8bf66&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d8bf66",
  null
  
)

export default component.exports